import React, { useCallback, useEffect, useState } from "react";
import { clone, equals, partial, pickBy } from "ramda";

import Box from "@material-ui/core/Box";

import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { MenuItem } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import LuxonUtils from "@date-io/luxon";
import Button from "@material-ui/core/Button";
import { notBlank } from "../../util/ext";
import TextField from "@material-ui/core/TextField";

const CadiEventSearchBar = ({ searchState, onSearch }) => {
  const [searchBy, setSearchBy] = useState("DATE");
  const [initialSearchState, _] = useState(clone(searchState));
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [filename, setFilename] = useState(null);
  const [status, setStatus] = useState("COMPLETE");

  useEffect(() => {
    if (notBlank(initialSearchState)) {
      setDateRange({
        startDate: initialSearchState.startDate,
        endDate: initialSearchState.endDate,
      });
    }
  }, [initialSearchState]);

  const handleSearchByChange = useCallback(
    event => {
      setSearchBy(event.target.value);
    },
    [setSearchBy],
  );

  const handleStatusChange = useCallback(
    event => {
      setStatus(event.target.value);
    },
    [setStatus],
  );

  const handleFilenameChange = useCallback(
    event => {
      setFilename(event.target.value);
    },
    [setFilename],
  );

  const handleDateRangeChange = useCallback(
    (key, value) => {
      setDateRange(prevState => ({ ...prevState, [key]: value }));
    },
    [setDateRange],
  );

  const handleSearchClick = useCallback(() => {
    const search = pickBy(notBlank, {
      searchBy,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      filename: filename,
      status: status,
    });

    console.log("Calling onSearch with:");
    console.log(search);

    onSearch(search);
  }, [
    searchBy,
    dateRange.startDate,
    dateRange.endDate,
    filename,
    status,
    onSearch,
  ]);

  return (
    <Box padding={4}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={3}>
          <FormControl fullWidth>
            <InputLabel id="search-by-select-label">Search By</InputLabel>
            <Select
              labelId="search-by-select-label"
              id="serch-by-select"
              value={searchBy}
              onChange={handleSearchByChange}
            >
              <MenuItem value="DATE">Date</MenuItem>
              <MenuItem value="FILENAME">Filename</MenuItem>
              <MenuItem value="STATUS">Status</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {equals(searchBy, "DATE") && (
          <Grid item xs={6}>
            <Grid container alignItems="center" direction="row" spacing={2}>
              <Grid item xs={6} sm={6}>
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                  <KeyboardDatePicker
                    fullWidth
                    autoOk
                    id="startDate"
                    format="MM/dd/yyyy"
                    label="From Date"
                    variant="inline"
                    value={dateRange.startDate}
                    onChange={partial(handleDateRangeChange, ["startDate"])}
                    KeyboardButtonProps={{
                      "aria-label": "change start date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={6} sm={6}>
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                  <KeyboardDatePicker
                    fullWidth
                    autoOk
                    id="endDate"
                    format="MM/dd/yyyy"
                    label="To Date"
                    variant="inline"
                    value={dateRange.endDate}
                    onChange={partial(handleDateRangeChange, ["endDate"])}
                    KeyboardButtonProps={{
                      "aria-label": "change end date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          </Grid>
        )}

        {equals(searchBy, "FILENAME") && (
          <Grid item xs={6}>
            <TextField
              id="filename"
              label="Filename"
              fullWidth
              value={filename || ""}
              onChange={handleFilenameChange}
            />
          </Grid>
        )}

        {equals(searchBy, "STATUS") && (
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="status-select-label">Status</InputLabel>
              <Select
                labelId="status-select-label"
                id="status-select"
                value={status}
                onChange={handleStatusChange}
              >
                <MenuItem value="COMPLETE">Complete</MenuItem>
                <MenuItem value="PROCESSING">Processing</MenuItem>
                <MenuItem value="FAILED">Failed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        )}

        <Grid item xs={3}>
          <Button variant="contained" onClick={handleSearchClick}>
            Search
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CadiEventSearchBar;
